export default __webpack_public_path__ + "static/media/all-call-history.7af7272b.svg";